import type { Dispatch } from 'react';
import { createContext } from 'react';
import type {
  FieldValue,
  FormAction,
  FormState,
  WidgetAction,
  WidgetState
} from './types';

export type FormContextType<
  T extends FieldValue = FieldValue,
  K extends string = string
> = {
  state: FormState<T, K>;
  dispatch: Dispatch<FormAction>;
};

export const FormContext = createContext<FormContextType>(
  // @ts-expect-error Хук используется внутри провайдера
  {}
);

export const WidgetContext = createContext(
  {} as {
    state: WidgetState;
    dispatch: Dispatch<WidgetAction>;
  }
);
